/**
 * Deployment environment names.
 *
 * Environment union ("dev" | "prod") and the Environments runtime array used
 * by utils/config.ts to validate the ENV value injected at runtime via
 * window.RUNTIME_CONFIG (frontend/public/config/config.js).
 */
export type Environment = "dev" | "prod";

export const Environments: readonly Environment[] = ["dev", "prod"];
